import { ClerkProvider as ClerkProviderBase } from "@clerk/react";
import type { ReactNode } from "react";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

interface ClerkProviderProps {
  children: ReactNode;
}

export function ClerkProvider({ children }: ClerkProviderProps) {
  return (
    <ClerkProviderBase publishableKey={PUBLISHABLE_KEY}>
      {children}
    </ClerkProviderBase>
  );
}
